import { Component, OnInit, OnDestroy, Inject, EventEmitter, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { combineLatest, Subscription } from "rxjs";
import { MktEnvironmentService } from "src/app/core/services/mkt-environment.service";
import { MktContentStorageService } from "src/app/core/services/mkt-content-storage.service";
import { FormGroup, FormBuilder, Validators, FormControl } from "@angular/forms";
import { DOCUMENT } from "@angular/common";
import { MktCommonModule } from "src/app/common/mkt-common.module";
@Component({
  selector: "app-earnings-calculator-section",
  templateUrl: "./earnings-calculator-section.component.html",
  styleUrls: ["./earnings-calculator-section.component.scss"],
  standalone: true,
  imports: [MktCommonModule]
})
export class EarningsCalculatorSectionComponent implements OnInit, OnDestroy {
  earningsCalculatorContent: any = null;
  imageBasePath: string = "";
  routeSub: Subscription = new Subscription();
  formGroup: FormGroup;
  isOpen: {} = {};
  totalPoints = 0;
  loyaltyPoints = 0;
  monthlyDollarMiles = 0;
  monthlyLoyalty = 0;
  previousValues = {};
  @Output() taggingValEmit = new EventEmitter<any>();

  constructor(
    private _mktContentStorageService: MktContentStorageService,
    private mktEnvironmentService: MktEnvironmentService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.imageBasePath = this.mktEnvironmentService.getEnvironmentVar(
      "cardsmkrHostName"
    );
  }

  ngOnInit(): void {
    this.getCalculatorContent();
    this.initializeFormGroup();
  }

  initializeFormGroup() {
    this.formGroup = this.fb.group({
      totalPoints: [
        0,
        [Validators.required]
      ]
    });
    this.totalPoints = 0;
    this.loyaltyPoints = 0;
    for (let i = 0; i < this.earningsCalculatorContent?.sliders.length; i++) {
      this.formGroup.addControl('sliderValue' + i, new FormControl(this.earningsCalculatorContent.sliders[i].defaultValue, [Validators.required, Validators.min(this.earningsCalculatorContent.sliders[i].minValue), Validators.max(this.earningsCalculatorContent.sliders[i].maxValue)]));
      this.previousValues['sliderValue' + i] = this.earningsCalculatorContent.sliders[i].defaultValue;
      this.totalPoints += (this.earningsCalculatorContent.sliders[i].pointsMultiplier * this.earningsCalculatorContent.sliders[i].defaultValue);
      this.loyaltyPoints += this.earningsCalculatorContent.sliders[i].defaultValue;
      for (let j = 0; j < this.earningsCalculatorContent.sliders[i]?.subSliders.length; j++) {
        this.formGroup.addControl('subSliderValue' + i + j, new FormControl(this.earningsCalculatorContent.sliders[i].subSliders[j].defaultSubValue, [Validators.required, Validators.min(this.earningsCalculatorContent.sliders[i].minValue), Validators.max(this.earningsCalculatorContent.sliders[i].maxValue)]));
        this.previousValues['subSliderValue' + i + j] = this.earningsCalculatorContent.sliders[i].subSliders[j].defaultSubValue;
      }
      this.isOpen["section" + i] = false;
    }
    this.pointsCalculation();
    const timeoutInstance = setTimeout(() => {
      this.injectData("monthly-dollar-miles", this.monthlyDollarMiles);
      this.injectData("monthly-loyalty", this.monthlyLoyalty);
      this.injectData("total-points", this.totalPoints);
      this.injectData("loyalty-points", this.loyaltyPoints);
      this.liveAnnouncer();
      clearTimeout(timeoutInstance);
    }, 500);
  }

  sliderCalculation(value, index) {
    value = this.formGroup.controls['sliderValue' + index].value;
    if (value === this.previousValues['sliderValue' + index]) return;
    this.totalPoints = 0;
    this.loyaltyPoints = 0;
    for (let i = 0; i < this.earningsCalculatorContent?.sliders.length; i++) {
      if (index === i) {
        this.totalPoints += this.earningsCalculatorContent?.sliders[i].pointsMultiplier * value;
        this.loyaltyPoints += value;
      }
      else {
        this.totalPoints += this.earningsCalculatorContent?.sliders[i].pointsMultiplier * this.formGroup.controls['sliderValue' + i].value;
        this.loyaltyPoints += this.formGroup.controls['sliderValue' + i].value;
      }
    }
    this.pointsCalculation();
    this.injectData("monthly-dollar-miles", this.monthlyDollarMiles);
    this.injectData("monthly-loyalty", this.monthlyLoyalty);
    this.injectData("total-points", this.totalPoints);
    this.injectData("loyalty-points", this.loyaltyPoints);
    let baseValue = Math.floor((value) / (this.earningsCalculatorContent.sliders[index]?.subSliders.length * 10)) * 10;
    let remainder = (value % (this.earningsCalculatorContent.sliders[index]?.subSliders.length * 10)) / 10;
    for (let j = 0; j < this.earningsCalculatorContent.sliders[index]?.subSliders.length; j++) {
      if (j < remainder) {
        this.formGroup.controls['subSliderValue' + index + j].setValue(baseValue + 10);
        this.previousValues['subSliderValue' + index + j] = baseValue + 10;
      }
      else {
        this.formGroup.controls['subSliderValue' + index + j].setValue(baseValue);
        this.previousValues['subSliderValue' + index + j] = baseValue;
      }
    }
    this.previousValues['sliderValue' + index] = value;
    this.liveAnnouncer();
  }

  subSliderCalculation(value, indexI, indexJ) {
    value = this.formGroup.controls['subSliderValue' + indexI + indexJ].value;
    if((value === this.previousValues['subSliderValue' + indexI + indexJ])) return;
    let totalSubValues = 0
    for (let i = 0; i < this.earningsCalculatorContent?.sliders[indexI]?.subSliders.length; i++) {
      if (indexJ === i) totalSubValues += value;
      else totalSubValues += this.formGroup.controls['subSliderValue' + indexI + i].value;
    }
    if (totalSubValues > this.earningsCalculatorContent.sliders[indexI].maxValue) {
      let diffInValue = totalSubValues - this.earningsCalculatorContent.sliders[indexI].maxValue;
      value -= diffInValue;
      this.formGroup.controls['sliderValue' + indexI].setValue(this.earningsCalculatorContent.sliders[indexI].maxValue);
    }
    else {
      let changeInValue = (value - this.previousValues['subSliderValue' + indexI + indexJ]);
      this.formGroup.controls['sliderValue' + indexI].setValue(this.formGroup.controls['sliderValue' + indexI].value + changeInValue);
    }
    this.totalPoints = 0;
    this.loyaltyPoints = 0;
    for (let i = 0; i < this.earningsCalculatorContent?.sliders.length; i++) {
      this.totalPoints += this.earningsCalculatorContent?.sliders[i].pointsMultiplier * this.formGroup.controls['sliderValue' + i].value;
      this.loyaltyPoints += this.formGroup.controls['sliderValue' + i].value;
    }
    this.pointsCalculation();
    this.injectData("monthly-dollar-miles", this.monthlyDollarMiles);
    this.injectData("monthly-loyalty", this.monthlyLoyalty);
    this.injectData("total-points", this.totalPoints);
    this.injectData("loyalty-points", this.loyaltyPoints);
    this.previousValues['sliderValue' + indexI] = this.formGroup.controls['sliderValue' + indexI].value;
    this.previousValues['subSliderValue' + indexI + indexJ] = value;
    this.formGroup.controls['subSliderValue' + indexI + indexJ].setValue(value);
    this.liveAnnouncer();
  }

  ngOnDestroy() {
    this.routeSub.unsubscribe();
  }

  injectData (id: string, value) {
    if (!!this.document.getElementById(id))
      this.document.getElementById(id).innerHTML = value.toLocaleString();
  }

  
  pointsCalculation(): void{
    this.totalPoints *= this.earningsCalculatorContent.totalPointsMultiplier;
    this.loyaltyPoints *= this.earningsCalculatorContent.totalPointsMultiplier; 
    this.monthlyDollarMiles = (!!this.earningsCalculatorContent?.totalDivider) ? (this.totalPoints / this.earningsCalculatorContent?.totalDivider):this.totalPoints;
    this.monthlyLoyalty = (!!this.earningsCalculatorContent?.totalDivider) ? (this.loyaltyPoints / this.earningsCalculatorContent?.totalDivider):this.loyaltyPoints;    
  }

  liveAnnouncer(): void {
    if(this.earningsCalculatorContent?.liveAnnouncement){
      setTimeout(()=> {
        this.document.getElementById("resultSectionSR").innerHTML = this.earningsCalculatorContent?.liveAnnouncement
        ?.replace('$$TOTALPOINTS$$',this.totalPoints)
        ?.replace('$$LOYALTYPOINTS$$',this.loyaltyPoints)
        ?.replace('$$MONTHLYDOLLARMILES$$',this.monthlyDollarMiles)
        ?.replace('$$MONTHLYLOYALTY$$',this.monthlyLoyalty)
    },2000);
    }
  }

  private getCalculatorContent() {
    this.routeSub = combineLatest([this.route.params]).subscribe(params => {
      const cardName = params[0]["cardName"].replace(/\./g, "");
      // Try to get card pricing details
      const mainPdpContentObject = this._mktContentStorageService.get(
        "Product_Detail_Pages",
        "copy",
        cardName,
        undefined
      );
      if (!mainPdpContentObject) {
        return;
      }
      const earningsCalculatorContent = JSON.parse(
        mainPdpContentObject["earningsCalculatorSection"]
      );
      if (
        !earningsCalculatorContent ||
        !earningsCalculatorContent.calulatorActive
      ) {
        return;
      }
      this.earningsCalculatorContent = earningsCalculatorContent;
    });
  }

  sliderTagging(sliderSubHeading, sliderLabel, control, isEnabled?: boolean): void{
    if('accordion' === control){
      const accordionVal = {
        page_inter: `${sliderSubHeading}|${sliderLabel}|${isEnabled ? 'Hide' : 'Show'}`, 
      type: 'accordion'
    }; 
      this.taggingValEmit.emit(accordionVal);

    }else{
        const sliderVal = {
          page_inter: `${sliderSubHeading}|${sliderLabel}|${control}`, 
        type: 'slider'
      }; 
        this.taggingValEmit.emit(sliderVal);
    }

  }

  validateEventTaggingSlider(event, mainheading, subheading, slider): void{
    if(event?.type ==='keyup' && [37, 38, 39, 40].includes(event?.keyCode)){
      this.sliderTagging(mainheading, subheading, slider);
    }else if(event?.type ==='pointerdown') {
      const sliderHandle = (<HTMLDivElement>(<MouseEvent>event)?.target);
      if(sliderHandle?.getAttribute('class') === 'cds-handle'){
        this.sliderTagging(mainheading, subheading, slider);
      }
    }
  }

  validateEventTaggingLink(event, mainheading, subheading, link): void{
    if([13].includes(event?.keyCode)){
      const linkElem = (<HTMLDivElement>(<KeyboardEvent>event)?.target);
      this.taggingValEmit.emit({'link_name': linkElem.innerHTML, 'type':'link'});
    }else if(event?.type ==='pointerdown') {
      const linkElem = (<HTMLDivElement>(<MouseEvent>event)?.target);
      if(['thankyou-link','cititravel-link'].includes(linkElem?.id)){
        this.taggingValEmit.emit({'link_name': linkElem.innerHTML, 'type':'link'});
      }
    }
  }
}
